import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { BOOTSTRAP_BREAKPOINTS } from '@skippay/core/styles/media';
import { getResponsiveStyles } from '@skippay/core/styles/responsivity';
import { size } from '@skippay/core/styles/spacing';
import { color, fontSize, fontWeight, radius } from '@skippay/core/styles/variables';
import { shouldForwardProp } from '@skippay/core/utils/emotionUtils';

import { ButtonComponent as ButtonComponentProps } from './@types/button';
import ButtonComponent from './ButtonComponent';
import { danger, info, primary, secondary, warning } from './buttonVariants.styled';

export const SButton = styled(ButtonComponent, {
	shouldForwardProp: (prop) =>
		shouldForwardProp<ButtonComponentProps>(
			['variant', 'isBusy', 'noBorder', 'breakout', 'width'],
			prop
		),
})`
	-webkit-appearance: none !important;
	border-radius: ${radius('medium')};
	border: 2px solid transparent;
	display: inline-block;
	font-size: ${fontSize('content')};
	font-weight: ${fontWeight('strong')};
	line-height: ${size(6)};
	min-width: ${size(46)};
	outline: none;
	padding: ${size(3)} ${size(6)};
	text-align: center;
	text-decoration: none;
	transition:
		border 250ms ease,
		background 250ms ease,
		color 250ms ease;
	white-space: nowrap;
	&:focus-visible {
		outline: 1px dotted ${color('blue-500')};
		outline: 5px auto -webkit-focus-ring-color;
	}
	&:hover,
	&:focus {
		text-decoration: none;
	}
	&[disabled] {
		cursor: not-allowed;
		pointer-events: none;
	}
	${({ variant }) => {
		return getResponsiveStyles(variant, {
			danger,
			info,
			primary,
			secondary,
			warning,
		});
	}}
	${({ isBusy }) =>
		isBusy &&
		css`
			cursor: progress;
			position: relative;
			color: white;
		`}
	${({ noBorder }) =>
		noBorder &&
		css`
			border: transparent !important;
		`}
		${({ breakout }) =>
		breakout &&
		css`
			&:after {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
		`}
		${({ width }) =>
		width &&
		css`
			width: ${width === 'full' ? '100%' : width};
			min-width: auto;
		`};
	@media (max-width: ${BOOTSTRAP_BREAKPOINTS.SM}px) {
		width: 100%;
	}
`;

export const SIcon = styled.span<{ position: 'right' | 'left' }>`
	display: inline-block;
	position: relative;
	height: ${size(6)};
	width: ${size(6)};
	${({ position }) =>
		position === 'right'
			? css`
					margin-left: ${size(2)};
				`
			: css`
					margin-right: ${size(2)};
				`};
	svg,
	img {
		max-height: 100%;
		max-width: 100%;
	}
`;
